const initialState = {
  openAssistanceModal: false,
};
export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "LOGIN": {
      return {
        ...state,
        user: { ...payload },
      };
    }
    case "SET_ASSISTANCE_MODAL": {
      return {
        ...state,
        openAssistanceModal: payload,
      };
    }
    default:
      return state;
  }
};
